import api from './index'

export default {
	getMeterItemById (data, payload) {
		return api.fetch('/app/meter/get-item-by-id?' + api.queryBuild(data), {
			method: 'GET'
		}, payload)
	},
	getAllMeters (data, payload) {
		return api.fetch('/app/meter/get-all-meters?' + api.queryBuild(data), {
			method: 'GET'
		}, payload)
	}
}



// WEBPACK FOOTER //
// ./src/api/meter.js